<div *ngIf="this.isLoading" class="se-loader"></div>
<div>
  <div class="top-div">
    <div class="filter-sec pt-2">
      <input #filtr type="text" aria-label="search" [(ngModel)]="targetSearch"
             title={{labels.alarmSearch|translate}} class="input-globalsearch" size="50"
             placeholder={{labels.search|translate}}
             (input)="SearchFilter($event.target.value)">
      <a class="SearchLink">
        <em class="fa fa-search SearchIcon"></em>
      </a>
    </div>
  </div>
  <div class="hide-in-large" *ngIf="isMobile">
    <div class="row fixedSupportLegends">
      <div class="col status-text p-left-11 ">
        <p class="status">
          <span class="color danger"></span>
          <span>{{labels.high | translate}}</span>
        </p>
      </div><div class="col status-text">
        <p class="status">
          <span class="color warning">
          </span>
          <span>{{labels.low | translate}}</span>
        </p>
      </div>
      <div class="col status-text">
        <p class="status">
          <span class="color inactive">
          </span>
          <span>{{labels.tableDataDeviceInActive | translate}}</span>
        </p>
      </div>
    </div>
    <div class="mobile-support">
      <div class="container-fluid ">
        <div *ngIf="noData" class="row mt-3">
          <div class="card-mobile support-card">
            <div class="col card-col"> {{labels.noRecords | translate}}</div>
          </div>
        </div>
        <div class="row mt-3 alarm-list" *ngIf="!noData">
          <div class="card-mobile support-card" *ngFor="let alarm of alarmInfo | filterBy: targetSearch"
               [ngClass]="{'alarmActiveCritical': alarm.isActive==true && alarm.severity=='1',
             'alarmActiveWarning' : alarm.isActive==true && alarm.severity=='2',
             'alarmInactive':alarm.isActive==false}">
            <div class="row data-row" *ngFor="let col of cols">
              <div class="col card-col">
                <p class="mobile-grid-header">{{col.header|translate}}</p>

                <p class="mobile-grid-data" *ngIf="col.dataType ==='date'">
                  {{alarm[col.field] | date : 'dd-MM-yyyy HH:mm' }}
                </p>
                <p class="mobile-grid-data" *ngIf="col.dataType !='date' && col.field != 'isActive' && col.field != 'ruleIdName' && col.field != 'severity'">
                  {{alarm[col.field]}}
                </p>
                <p class="mobile-grid-data" *ngIf="col.field == 'isActive'">
                  {{ alarm[col.field] == true ? 'Active' : 'Inactive' }}
                </p>
                <p class="mobile-grid-data" *ngIf="col.field == 'severity'">
                  {{ alarm[col.field] == 1 ? 'Critical' : 'Warning' }}
                </p>
                <p class="mobile-grid-data" *ngIf="col.field == 'ruleIdName'">
                  {{col.dataType=='date'? (alarm[col.field]| date:'dd/MM/yyyy HH:mm') : alarm[col.field]}}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="hide-in-mobile" *ngIf="!isMobile">
    <div class="grid-div mb-3">
      <div>
        <div class="rectangle-grid">
          <p-table  #dt [columns]="cols" [value]="alarmInfo" [paginator]="isPagination" [rows]="10"
                   [globalFilterFields]="['dongleUId','deviceName','locationCountry','ruleIdName','resourceName']">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th scope="col" class="width0-25em"></th>
                <th scope="col" class="alarm-header width0-25em">#</th>
                <th scope="col" class="alarm-header" *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}">
                  {{col.header| translate}}
                  <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                </th>

              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
              <tr class="rowHeight">
                <td>
                  <img title="Critical Alarm" alt="Critical" width="15px" height="14px" *ngIf="rowData.isActive==true && rowData.severity=='1'" src="assets/alarmSeverity2.svg" />
                  <img title="Warning Alarm" alt="Warning" width="15px" height="14px" *ngIf="rowData.isActive==true && rowData.severity=='2'" src="assets/alarmSeverity1.svg" />
                  <img title="Inactive Alarm" alt="Inactive" width="14px" height="14px" *ngIf="rowData.isActive==false " src="assets/alarm-Inactive.svg" />
                </td>
                <td>
                  {{i+1}}
                </td>
                <td *ngFor="let col of columns">
                  <span *ngIf="col.dataType=='date'" appendTo="target" class="relativePosition" dateFormat="dd/MM/yyyy HH:mm:ss">
                    {{ rowData[col.field] | date:'dd/MM/yyyy HH:mm' }}
                  </span>
                  <span *ngIf="col.dataType !='date' && col.field != 'isActive' && col.field != 'ruleIdName' && col.field != 'severity'" appendTo="target" class="relativePosition" dateFormat="dd/MM/yyyy HH:mm:ss">
                    {{ rowData[col.field] }}
                  </span>
                  <span *ngIf="col.field == 'isActive'">
                    {{ rowData[col.field] == true ? 'Active' : 'Inactive' }}
                  </span>
                  <span *ngIf="col.field == 'severity'">
                    {{ rowData[col.field] == 1 ? 'Critical' : 'Warning' }}
                  </span>
                  <a class="hlink ruleDetails" (click)="getRuleDetails(rowData)">
                    <span *ngIf="col.field == 'ruleIdName'" appendTo="target" class="relativePosition" dateFormat="dd/MM/yyyy HH:mm">
                      {{col.dataType=='date'? (rowData[col.field]| date:'dd/MM/yyyy HH:mm') : rowData[col.field]}}
                    </span>
                  </a>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr *ngIf="noData">
                <td [attr.colspan]="columns.length+2">
                  {{labels.noRecords | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>

  </div>
  <div class="se-dialog" #ruleContent *ngIf="showRuleDetails">
    <div class="se-dialog-holder">
      <div class="se-complex-header">
        <h3 class="se-dialiog-title">{{contentHeader| translate}}</h3>
      </div>
      <div class="se-dialog-body">
        <div *ngIf="this.isLoading" class="se-loader"></div>
        <div class="se-inline-form">
          <!-- alarm name -->
          <div class="form-ele col-md-12">
            <label for="txtAlarmName" class="se-label col-md-3">{{labels.alarmName | translate}}<span>*</span></label>
            <input id="txtAlarmName" disabled placeholder="{{labels.alarmName | translate}}" type="text" autocomplete="off" class="se-form-control col-md-6 disabled-filed" [(ngModel)]="alarmRuleName" #txtAlarmName
                   #alarmName="ngModel" [fieldName]="'Alarm Name'" [minLength]="1" [maxLength]="500">

          </div>
          <div class="form-ele col-md-12">
            <label class="se-label col-md-3"> {{labels.tableHeaderDongleUId | translate}}</label>
            <input id="selectedDongleUId" disabled [(ngModel)]="selectedDongleUId" class="se-form-control col-md-6 disabled-filed">
          </div>
          <!-- resources by controller -->
          <div class="form-ele col-md-12">
            <label class="se-label col-md-3"> {{labels.resources | translate}}</label>
            <input id="selectedRes" disabled [(ngModel)]="selectedRes" class="se-form-control col-md-6 disabled-filed">

          </div>
          <div class="form-ele" *ngIf="!showAlarmWhen">
            <!-- min res value -->
            <div class="form-ele col-md-12">
              <label for="minVal" class="se-label col-md-3"> {{labels.limit| translate}} ({{labels.min| translate}})<span>*</span></label>
              <input id="minVal" disabled type="number" autocomplete="off" [(ngModel)]="minVal" class="se-form-control col-md-6 disabled-filed" #minLimit="ngModel" [fieldName]="'Min Limit'">

            </div>
            <!-- max res value -->
            <div class="form-ele col-md-12">
              <label for="maxVal" class="se-label col-md-3"> {{labels.limit| translate}} ({{labels.max| translate}})<span>*</span></label>
              <input id="maxVal" disabled type="number" autocomplete="off" [(ngModel)]="maxVal" class="se-form-control col-md-6 disabled-filed" #maxLimit="ngModel" [fieldName]="'Max Limit'">

            </div>
          </div>
          <div *ngIf="showAlarmWhen" class="mb-3">
            <div class="form-ele col-md-12">
              <label for="alarmWhen" class="se-label col-md-3"> {{labels.alarmWhen| translate}}<span>*</span></label>
              <select disabled id="drpAlarmWhen" aria-label="drpAlarmWhen" class="se-form-control col-md-6" [(ngModel)]="selectedalarmWhen">
                <option *ngFor="let item of alarmWhenList; let i = index" [ngValue]="item.value">{{item.desc|translate}}</option>
              </select>
            </div>
          </div>
          <!-- notified to email -->
          <div class="form-ele col-md-12">
            <label for="txtNotifiedTo" class="se-label col-md-3">{{labels.notify| translate}}<span>*</span></label>
            <textarea id="txtNotifiedTo"  disabled type="text" [(ngModel)]="notifiedTo" #txtNotify
                   class="se-form-control col-md-6 disabled-filed" #NotifiedTomail="ngModel"></textarea>
          </div>

          <!-- severity -->
          <div class="form-ele col-md-12">
            <label class="se-label disabled-filed col-md-3"> {{labels.severity | translate}}<span>*</span></label>
            <label class="radio-holder col-md-2">
              <span>{{labels.high|translate}}</span>
              <input class="radio disabled-filed" disabled type="radio" name="severity" [value]='1' [(ngModel)]="severity">
              <span class="checkmark" data-color="primary"></span>
            </label>
            <label class="radio-holder disabled-filed col-md-2">
              <span>{{labels.low|translate}}</span>
              <input type="radio" disabled name="severity" [value]='2' [(ngModel)]="severity" class="radio disabled-filed">
              <span class="checkmark" data-color="primary"></span>
            </label>
          </div>

          <div class="form-ele col-md-12">
            <label for="delay" class="se-label col-md-3"> {{labels.delay| translate}}</label>
            <input id="delayVal" aria-label="txtDelay" type="number" disabled [(ngModel)]="delay" class="se-form-control col-md-3 disabled-filed" #delayLimit="ngModel" [fieldName]="'Delay'" (change)="validateForm()">
            <span for="min" class="col-md-1"> {{labels.minute| translate}}</span>

          </div>
        </div>
      </div>
      <div class="se-dialog-footer">
        <button class="se-button" (click)="closeModal()">{{labels.close | translate}}</button>
      </div>

    </div>
  </div>


</div>
